export default "__VITE_ASSET__ve1p0o7h__"